import {setArchivedProjectList, setDeletedProjectList, setDeletedWeekReportList, setProjectList} from "../actions";
import Facade from "../Facade";

export default function runRefreshDeletedWeeklyList ( page,limit,dispatch )
{
  //刷新
  Facade.gw.getRecycleWeekly(page,limit,({total,data}) => {
    dispatch(setDeletedWeekReportList(total,data,page,limit));
  });
}